<section class="tech-data-overview">
  <div class="product-configurator-banner">
    <div class="banner-container-left">
      <img
        [src]="config.piaAPIOrigin + '/' + productImage() | authImage"
        alt=""
        class="banner-image"
      />

      <div class="banner-text-container">
        <h3 class="banner-heading font-m">
          {{
            "features.product-tech-data.productConfiguratorBannerHeading"
              | translate
          }}
        </h3>
        <p class="banner-paragraph font-m">
          {{
            "features.product-tech-data.productConfiguratorBannerParagraph"
              | translate
          }}
        </p>
      </div>
    </div>
    <a
      href="https://www.claas.com/en-be/agricultural-machinery/product-configurator"
      target="_blank"
      rel="noopener noreferrer"
      class="configure-now-button"
    >
      <claas-icon
        class="anchor-link-icon"
        iconId="648660"
        [namespace]="'pia'"
        [attr.aria-hidden]="true"
        [size]="24"
        [alt]="''"
        [removeDefaultColor]="true"
      >
      </claas-icon
      ><span class="anchor-link-text font-m">{{
        "features.product-tech-data.productConfiguratorConfigureNowButtonText"
          | translate
      }}</span></a
    >
  </div>
  <div class="tech-data">
    <dl class="tech-grid">
      @for (techDataItem of techData(); track techDataItem) {
        <div class="tech-item">
          <dt class="tech-term font-xs">{{ techDataItem.categoryTitle }}</dt>
          <dd class="tech-desc font-xs">
            {{ techDataItem.Value }}
            <span>
              @if (techDataItem.Unit) {
                {{
                  "features.product-tech-data.units." + techDataItem.Unit
                    | translate
                }}
              }
            </span>
          </dd>
        </div>
      }
    </dl>
  </div>
</section>
